import { eventBus } from '@tools/event-bus';

export function resetOpenedDropdowns() {
  document.querySelectorAll('.drop-down-menu__item ul').forEach((menuItem) => {
    menuItem.classList.remove('display-flex');
  });
  document.querySelectorAll('.drop-down-menu__item.active').forEach((menuItem) => {
    menuItem.classList.remove('active');
  });
}

export function dropdownMenu(type) {
  // Init onClick behavior on menu - #MATCH-2754
  if (!window.BREAKPOINTS.isDesktop && !window.BREAKPOINTS.isTabletLarge) {
    return;
  }
  window.addEventListener('click', (event) => {
    const element = event.target.closest('li');
    if (!element) {
      // Click outside the dropdown should close the open dropdown
      resetOpenedDropdowns(type);
      return;
    }
    if (element && element.classList.contains(`drop-down-menu__${type}`)) {
      // If user clicks from one tab to another tab : we should remove previously opened tabs
      const ul = element.querySelector('ul');
      const closestLi = element;
      if (closestLi.classList.contains('active')) {
        // Case: User clicks on currently opened menu item to close it
        closestLi.classList.remove('active');
        ul.classList.remove('display-flex');
        return;
      }
      resetOpenedDropdowns();
      // Case: User clicks on a closed menu item to open it
      ul.classList.add('display-flex');
      closestLi.classList.add('active');
    }
  });

  document.querySelectorAll(`.drop-down-menu__${type}`).forEach((menuItem) => {
    menuItem.setAttribute('data-ready', true);
  });

  // Close the dropdown when scrolling down since the header is progressively concealed
  if (document.querySelector('#search-app')) {
    const header = document.getElementById('header');
    const banner = document.getElementById('banner');
    const observer = new IntersectionObserver((entries) => {
      if (entries && entries[0].boundingClientRect.top <= 0) {
        resetOpenedDropdowns();
      }
    }, (banner) ? {
      rootMargin: `-${header.getBoundingClientRect().height}px 0px 0px 0px`,
    } : {});

    observer.observe(header);
  }

  const anonymousLogin = document.getElementById('anonymous-login');
  if (anonymousLogin) {
    anonymousLogin.addEventListener('click', (event) => {
      event.preventDefault();
      eventBus.dispatchEvent(new CustomEvent('show-login-modal'));
      resetOpenedDropdowns();
    });
  }

  const anonymousRegister = document.getElementById('anonymous-register');
  if (anonymousRegister) {
    anonymousRegister.addEventListener('click', (event) => {
      event.preventDefault();
      eventBus.dispatchEvent(new CustomEvent('show-register-choice-modal', { detail: window.location.href }));
      resetOpenedDropdowns();
    });
  }
}
